module.exports = __webpack_public_path__ + "img/mgh-kyoto-kawaramachi-jokyoji-sp.15770d18.jpg";